module.exports = __webpack_public_path__ + "img/reviewplatforms-collection.042903f5.png";